import request from "@/utils/request";

export function login(msg) {
  return request({
    url: "/api/v1/authorizations",
    method: "post",
    data: msg
  });
}

export function getInfo() {
  return request({
    url: "/api/v1/trainusers/user",
    method: "post"
  });
}

export function getCode(msg) {
  return request({
    url: "/api/v1/verificationcodes",
    method: "post",
    data: msg
  });
}

export function getMsgCode(username) {
  return request({
    url: "/api/v1/captchas",
    method: "post",
    data: {
      username: username
    }
  });
}

export function logout() {
  return request({
    url: "auth/logout",
    method: "delete"
  });
}
